import { render, staticRenderFns } from "./PrincipalRevenueGuideDialog.vue?vue&type=template&id=79e44988&scoped=true"
import script from "./PrincipalRevenueGuideDialog.vue?vue&type=script&lang=js"
export * from "./PrincipalRevenueGuideDialog.vue?vue&type=script&lang=js"
import style0 from "./PrincipalRevenueGuideDialog.vue?vue&type=style&index=0&id=79e44988&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e44988",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e44988')) {
      api.createRecord('79e44988', component.options)
    } else {
      api.reload('79e44988', component.options)
    }
    module.hot.accept("./PrincipalRevenueGuideDialog.vue?vue&type=template&id=79e44988&scoped=true", function () {
      api.rerender('79e44988', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/PrincipalRevenueGuideDialog.vue"
export default component.exports